/**
 * Conserva a dónde iba el usuario cuando se le mandó al login.
 *
 * POR QUÉ EXISTE
 * ──────────────
 * El correo de cuota al 90 % enlaza a `/addon?addon=addon_mensajes`, y ese
 * parámetro preselecciona el add-on en la tienda. Pero `App.js` redirige
 * `/addon` a `/` cuando no hay sesión, y ahí se perdía la ruta entera.
 *
 * **El enlace del correo llega sin sesión más veces de las que llega con ella**:
 * el dueño abre el email en el móvil, no en la pestaña donde tiene la app
 * abierta. Sin esto, el caso mayoritario aterrizaba en la tienda sin
 * preselección — justo lo que el parámetro venía a evitar.
 *
 * SESSIONSTORAGE Y NO LOCALSTORAGE, a propósito: el destino pertenece a ESTA
 * navegación. Un `localStorage` sobreviviría a cerrar el navegador y mandaría al
 * usuario a la tienda de add-ons dos días después, sin que él entienda por qué.
 *
 * SE CONSUME AL LEERLO. Un destino que se queda es peor que ninguno: convierte
 * cada login posterior en un salto inesperado.
 */

const CLAVE = 'pux.destinoTrasLogin';

/** Ventana corta: el login es de segundos, no de horas. */
const VIGENCIA_MS = 15 * 60 * 1000;

/**
 * Sólo rutas internas. `//evil.com` es una URL absoluta protocol-relative que
 * el navegador resuelve fuera del sitio, así que empezar por `/` no basta.
 */
function esRutaInterna(ruta) {
  return typeof ruta === 'string'
    && ruta.startsWith('/')
    && !ruta.startsWith('//')
    && !ruta.startsWith('/\\');
}

export function guardarDestino(ruta) {
  if (!esRutaInterna(ruta)) return;
  try {
    sessionStorage.setItem(CLAVE, JSON.stringify({ ruta, en: Date.now() }));
  } catch {
    // Modo privado, cookies bloqueadas: se pierde la preselección y nada más.
    // No es motivo para romper la navegación al login.
  }
}

/** Devuelve el destino guardado y lo borra. `null` si no hay, caducó o no vale. */
export function consumirDestino() {
  return leerDestino({ borrar: true });
}

/**
 * Devuelve el destino guardado SIN borrarlo. Lo usa la pantalla de login para saber si la
 * persona viene a contratar (`/contratar?intent=contratar&plan=…`, bloque 1 · C6a) mientras
 * el destino sigue esperando a que `RedirigirTrasLogin` lo consuma tras entrar.
 */
export function verDestino() {
  return leerDestino({ borrar: false });
}

function leerDestino({ borrar }) {
  try {
    const crudo = sessionStorage.getItem(CLAVE);
    if (!crudo) return null;
    if (borrar) sessionStorage.removeItem(CLAVE);
    const { ruta, en } = JSON.parse(crudo);
    if (!esRutaInterna(ruta)) return null;
    if (!Number.isFinite(en) || Date.now() - en > VIGENCIA_MS) return null;
    return ruta;
  } catch {
    return null;
  }
}
